import * as React from 'react'

import Avatar from '@mui/material/Avatar'
import Stack from '@mui/material/Stack'

import { I18n, useTranslation } from 'components/hooks/use-translation'
import Icon from 'components/atomic/atoms/icon'
import Text from 'components/atomic/atoms/text'

interface TestimonialProps {
    avatar: string
    name: string
    occupation: string
    quote: string
}

const Testimonial = (props: TestimonialProps) => {
    const { t }: I18n = useTranslation()
    return (
        <Stack spacing={3} direction="row">
            <Avatar alt="" sx={{ width: 80, height: 80 }} src={props.avatar} />
            <Stack>
                <Stack direction="row" spacing="0.5rem" alignItems="center">
                    <Icon fontSize="small" color="primary" name="taskAliIcon" />
                    <Text variant="overline" color="primary">
                        {t('path:testimonialSection.name', {
                            name: props.name,
                            occupation: props.occupation,
                        })}
                    </Text>
                </Stack>
                <Text variant="h6">{`"${props.quote}"`}</Text>
            </Stack>
        </Stack>
    )
}

export default Testimonial
